module.exports = __webpack_public_path__ + "static/img/pic-02@2x.9c2d371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-02@2x.png
// module id = awGH
// module chunks = 1